module.exports = __webpack_public_path__ + "static/media/naver.206ea910.svg";